import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import Card from "@mui/material/Card";
import Button from "@mui/material/Button";
import HomeIcon from "@mui/icons-material/Home";
import MDBox from "components/MDBox";
import BasicLayout from "../components/BasicLayout";
import cancelDeletion from "api/auth/cancelDeletion";
function CancelDeletion() {
  const { t } = useTranslation();
  const [tokenStatus, setTokenStatus] = useState("");

  function tryValidation() {
    const url = window.location.href;
    const splitted = url.split("token=");
    if (splitted && splitted[1]) {
      const token = splitted[1];
      setTokenStatus("checking");
      cancelDeletion(token)
        .then((res) => {
          if (res) {
            setTokenStatus("success");
          } else {
            setTokenStatus("error");
          }
        })
        .catch((err) => {
          // eslint-disable-next-line
          console.log("error while validating email token:", err);
          setTokenStatus("error");
        });
    } else {
      setTokenStatus("no_token");
    }
  }

  // Run validation when component mounts
  useEffect(() => {
    tryValidation();
  }, []);

  function getStatusContent() {
    switch (tokenStatus) {
      case "success":
        return (
          <div className="email_validation_success">
            <h3>{t("credentialConfirmation.success_title_cancel_deletion")}</h3>
            <p>{t("credentialConfirmation.success_text_cancel_deletion")}</p>
            <MDBox mt={3} mb={1} textAlign="center">
              <Button
                component={Link}
                to="/"
                variant="contained"
                color="light"
                startIcon={<HomeIcon />}
              >
                {t("credentialConfirmation.go_to_home_cancel_deletion")}
              </Button>
            </MDBox>
          </div>
        );

      case "checking":
        return (
          <div className="email_validation_checking">
            <h3>{t("credentialConfirmation.checking_title_cancel_deletion")}</h3>
            <p>{t("credentialConfirmation.checking_text_cancel_deletion")}</p>
          </div>
        );

      case "error":
        return (
          <div className="email_validation_error">
            <h3>{t("credentialConfirmation.error_title_cancel_deletion")}</h3>
            <p>{t("credentialConfirmation.error_text_cancel_deletion")}</p>
          </div>
        );

      case "no_token":
      default:
        return (
          <div className="email_validation_no_token">
            <h3>{t("credentialConfirmation.no_token_title_cancel_deletion")}</h3>
            <p>{t("credentialConfirmation.no_token_text_cancel_deletion")}</p>
          </div>
        );
    }
  }

  return (
    <BasicLayout>
      <Card>
        <MDBox pt={4} pb={4} px={3}>
          <MDBox component="form" role="form" textAlign="center">
            {getStatusContent()}
          </MDBox>
        </MDBox>
      </Card>
    </BasicLayout>
  );
}

export default CancelDeletion;
